const structure = "/images/info/notImg.png";


export {
    structure 
}